(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ilor-air-benefits"] && !Shopify.designMode) return;
  try {
    
  if(!customElements.get('ilor-air-benefits'))customElements.define('ilor-air-benefits',class extends HTMLElement{
    connectedCallback(){
      if(this.initialized){this.observer?.observe(this);return}this.initialized=true;
      this.control=this.querySelector('.iab__motion');this.control.hidden=false;
      this.control.addEventListener('click',()=>{const paused=this.classList.toggle('is-paused');this.control.setAttribute('aria-pressed',String(paused));this.control.textContent=paused?'Animation fortsetzen':'Animation pausieren'});
      if('IntersectionObserver'in window){this.observer=new IntersectionObserver(entries=>this.classList.toggle('is-visible',entries[0].isIntersecting),{rootMargin:'50px'});this.observer.observe(this)}else this.classList.add('is-visible');
    }
    disconnectedCallback(){this.observer?.disconnect()}
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ilor-everyday-places"] && !Shopify.designMode) return;
  try {
    
  if(!customElements.get('ilor-everyday-places'))customElements.define('ilor-everyday-places',class extends HTMLElement{
    connectedCallback(){
      this.controller=new AbortController();const signal=this.controller.signal;
      this.slides=[...this.querySelectorAll('.ilp__slide')];this.segments=[...this.querySelectorAll('.ilp__segment')];
      this.index=Math.max(0,this.slides.findIndex(s=>s.classList.contains('is-active')));this.duration=Math.max(4000,Number(this.dataset.duration)||5000);
      this.style.setProperty('--ilp-duration',this.duration+'ms');this.paused=false;this.visible=false;this.busy=false;this.epoch=0;
      this.motion=matchMedia('(prefers-reduced-motion:reduce)');this.button=this.querySelector('.ilp__pause');
      this.button.hidden=this.slides.length<2;this.button.setAttribute('aria-pressed','false');this.button.textContent='Bildwechsel pausieren';
      this.button.addEventListener('click',()=>{this.paused=!this.paused;this.button.setAttribute('aria-pressed',String(this.paused));this.button.textContent=this.paused?'Bildwechsel fortsetzen':'Bildwechsel pausieren';this.sync()},{signal});
      document.addEventListener('visibilitychange',()=>this.sync(),{signal});this.motion.addEventListener('change',()=>this.sync(),{signal});
      if('IntersectionObserver'in window){this.observer=new IntersectionObserver(entries=>{this.visible=entries[0].isIntersecting;this.sync()},{threshold:.1});this.observer.observe(this)}else{this.visible=true;this.sync()}
    }
    canRun(){return this.isConnected&&this.visible&&!this.paused&&!this.motion.matches&&!document.hidden&&this.slides.length>1}
    sync(){clearTimeout(this.timer);this.epoch++;this.classList.remove('is-playing');if(this.canRun()){this.segments[this.index]?.querySelector('i')?.getAnimations().forEach(a=>{a.currentTime=0});this.classList.add('is-playing');this.preload((this.index+1)%this.slides.length);this.timer=setTimeout(()=>this.advance(),this.duration)}}
    preload(index){const img=this.slides[index]?.querySelector('img');if(!img)return Promise.resolve(false);if(img.complete&&img.naturalWidth)return Promise.resolve(true);if(img._ilpLoad)return img._ilpLoad;img._ilpLoad=new Promise(resolve=>{let done=false;const finish=ok=>{if(done)return;done=true;clearTimeout(timeout);resolve(ok)};const timeout=setTimeout(()=>finish(false),8000);img.addEventListener('load',()=>finish(true),{once:true});img.addEventListener('error',()=>finish(false),{once:true});if(img.dataset.src){img.loading='eager';if(img.dataset.srcset)img.srcset=img.dataset.srcset;img.src=img.dataset.src;delete img.dataset.src;delete img.dataset.srcset}else if(img.complete)finish(img.naturalWidth>0)});return img._ilpLoad}
    async advance(){if(!this.canRun()||this.busy)return;this.busy=true;const epoch=this.epoch;try{for(let offset=1;offset<this.slides.length;offset++){const next=(this.index+offset)%this.slides.length;const loaded=await this.preload(next);if(epoch!==this.epoch||!this.canRun())return;if(!loaded)continue;this.slides.forEach((slide,i)=>{slide.classList.toggle('is-active',i===next);slide.setAttribute('aria-hidden',String(i!==next))});this.segments.forEach((segment,i)=>{segment.classList.toggle('is-current',i===next);segment.classList.toggle('is-complete',i<next)});this.querySelectorAll('[data-place]').forEach(el=>el.textContent=this.slides[next].dataset.location);this.index=next;break}}finally{this.busy=false;if(this.isConnected)this.sync()}}
    disconnectedCallback(){clearTimeout(this.timer);this.epoch++;this.observer?.disconnect();this.controller?.abort();this.classList.remove('is-playing')}
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ilor-flavor-showcase"] && !Shopify.designMode) return;
  try {
    
  if(!customElements.get('ilor-flavor-showcase'))customElements.define('ilor-flavor-showcase',class extends HTMLElement{
    connectedCallback(){
      this.abort=new AbortController();const signal=this.abort.signal;this.slides=[...this.querySelectorAll('.ifs__slide')];this.index=Math.max(0,this.slides.findIndex(s=>s.classList.contains('is-active')));this.delay=Math.max(4000,Number(this.dataset.interval)||5000);this.visible=false;this.paused=false;this.epoch=0;this.motion=matchMedia('(prefers-reduced-motion:reduce)');this.dialog=this.querySelector('dialog');this.pauseButton=this.querySelector('.ifs__pause');this.pauseButton.hidden=this.slides.length<2;
      this.querySelectorAll('[data-step]').forEach(b=>b.addEventListener('click',()=>this.show(this.index+Number(b.dataset.step)),{signal}));this.querySelectorAll('[data-select]').forEach(b=>b.addEventListener('click',()=>this.show(Number(b.dataset.select)),{signal}));
      this.pauseButton.addEventListener('click',()=>{this.paused=!this.paused;this.pauseButton.setAttribute('aria-pressed',String(this.paused));this.pauseButton.textContent=this.paused?'Automatischen Wechsel fortsetzen':'Automatischen Wechsel pausieren';this.sync()},{signal});
      this.querySelectorAll('[data-open-flavor]').forEach(b=>b.addEventListener('click',()=>{const slide=b.closest('.ifs__slide'),img=slide.querySelector('.ifs__photo'),target=this.dialog.querySelector('[data-dialog-image]');target.src=img.currentSrc||img.src;target.alt=img.alt;this.dialog.querySelector('[data-dialog-name]').textContent=slide.dataset.name;this.dialog.querySelector('[data-dialog-description]').textContent=slide.dataset.description;this.dialog.showModal();this.sync()},{signal}));this.querySelector('[data-close-flavor]').addEventListener('click',()=>this.dialog.close(),{signal});this.dialog.addEventListener('close',()=>this.sync(),{signal});this.dialog.addEventListener('click',e=>{if(e.target===this.dialog){const r=this.dialog.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)this.dialog.close()}},{signal});
      document.addEventListener('visibilitychange',()=>this.sync(),{signal});this.motion.addEventListener('change',()=>this.sync(),{signal});this.addEventListener('shopify:block:select',e=>{const index=this.slides.indexOf(e.target.closest('.ifs__slide'));if(index>=0){this.paused=true;this.pauseButton.setAttribute('aria-pressed','true');this.pauseButton.textContent='Automatischen Wechsel fortsetzen';this.show(index)}},{signal});
      if('IntersectionObserver'in window){this.observer=new IntersectionObserver(es=>{this.visible=es[0].isIntersecting;this.sync()},{threshold:.1});this.observer.observe(this)}else{this.visible=true;this.sync()}
    }
    canRun(){return this.isConnected&&this.visible&&!this.paused&&!this.motion.matches&&!document.hidden&&!this.dialog.open&&this.slides.length>1}
    sync(){clearTimeout(this.timer);this.epoch++;this.classList.toggle('is-running',this.canRun());if(this.canRun()){this.load((this.index+1)%this.slides.length);this.timer=setTimeout(()=>this.show(this.index+1),this.delay)}}
    load(index){const img=this.slides[index]?.querySelector('.ifs__photo');if(!img)return Promise.resolve(false);if(img.complete&&img.naturalWidth)return Promise.resolve(true);if(img._ifsLoad)return img._ifsLoad;img._ifsLoad=new Promise(resolve=>{let done=false;const finish=ok=>{if(done)return;done=true;clearTimeout(timer);resolve(ok)};const timer=setTimeout(()=>finish(false),8000);img.addEventListener('load',()=>finish(true),{once:true});img.addEventListener('error',()=>finish(false),{once:true});if(img.dataset.src){img.loading='eager';if(img.dataset.srcset)img.srcset=img.dataset.srcset;img.src=img.dataset.src;delete img.dataset.src;delete img.dataset.srcset}else if(img.complete)finish(img.naturalWidth>0)});return img._ifsLoad}
    async show(index){clearTimeout(this.timer);const next=(index+this.slides.length)%this.slides.length,token=++this.epoch,ok=await this.load(next);if(!this.isConnected||token!==this.epoch)return;if(!ok){this.sync();return}this.slides.forEach((slide,i)=>{slide.classList.toggle('is-active',i===next);slide.setAttribute('aria-hidden',String(i!==next));slide.inert=i!==next});this.querySelectorAll('[data-select]').forEach(b=>b.setAttribute('aria-pressed',String(Number(b.dataset.select)===next)));this.index=next;const row=this.querySelector('.ifs__thumbs'),thumb=row.querySelector('[data-select="'+next+'"]');if(thumb&&row.scrollWidth>row.clientWidth){const left=thumb.offsetLeft-row.firstElementChild.offsetLeft-(row.clientWidth-thumb.clientWidth)/2;row.scrollTo({left,behavior:this.motion.matches?'instant':'smooth'})}this.sync()}
    disconnectedCallback(){clearTimeout(this.timer);this.epoch++;this.observer?.disconnect();this.abort?.abort();if(this.dialog?.open)this.dialog.close();this.classList.remove('is-running')}
  });

  } catch(e) { console.error(e); }
})();
})();
